module.exports = __webpack_public_path__ + "assets/img/bayer-logo.76ff62ae.png";